import colors from "../../theme/Colours";

export const mainContainer = {
  display: "flex",
  backgroundColor: { xs: "none", sm: colors.background2 },
  gap: { xs: "20px", md: "38px" },
  paddingY: { xs: "10px", sm: "15px" },
  paddingRight: "44px",
};

export const titleStyle = {
  fontFamily: "Poppins",
  fontSize: { xs: "12px", sm: "24px" },
  fontWeight: 500,
  color: colors.textColor2,
};

export const orderStyles = {
  display: "flex",
  flexDirection: { xs: "column", sm: "row" },
  justifyContent: { sm: "space-between" },
  gap: { xs: "26px", sm: "0" },
  flexGrow: 1,
};

export const textStyle = {
  fontFamily: "Poppins",
  fontSize: { xs: "8px", sm: "16px" },
  fontWeight: 400,
  color: colors.textColor2,
};

export const spaceBetween = {
  display: "flex",
  flexDirection: "column",
  gap: { xs: "6px", sm: "12px" },
};

export const calculationBox = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  fontFamily: "Poppins",
  fontSize: { xs: "10px", sm: "15px" },
  fontWeight: 600,
  color: colors.textColor2,
  borderWidth: "1px",
  borderRadius: "8px",
  borderColor: colors.buttonOutlinedBorderColor,
  padding: { xs: "2px 6px", sm: "0px 11px" },
  width: { xs: "123px", sm: "160px" },
  height: { xs: "20px", sm: "36px" },
};

export const inheritFont = {
  fontFamily: "inherit",
  fontSize: "inherit",
  fontWeight: "inherit",
};
